// components/hauler/StatusPill.js
// Compact status badge used in JobDetail / RouteScreen / JobCard.

import React from "react";

const PALETTE = {
  available:    { bg: "rgba(61,144,217,.12)",  border: "#3D90D9", color: "#3D90D9", label: "Available" },
  claimed:      { bg: "rgba(3,166,106,.12)",   border: "#03A66A", color: "#03A66A", label: "Claimed" },
  en_route:     { bg: "rgba(242,151,39,.15)",  border: "#F29727", color: "#F29727", label: "On the way" },
  in_progress:  { bg: "rgba(242,151,39,.18)",  border: "#F29727", color: "#F29727", label: "In progress" },
  complete:     { bg: "rgba(242,242,242,.06)", border: "rgba(242,242,242,.3)", color: "rgba(242,242,242,.7)", label: "Complete" },
};

export default function StatusPill({ status }) {
  const p = PALETTE[status] || PALETTE.available;
  return (
    <span style={{
      display: "inline-block",
      fontSize: 10,
      fontWeight: 800,
      letterSpacing: 1,
      padding: "3px 9px",
      borderRadius: 999,
      background: p.bg,
      border: `1px solid ${p.border}`,
      color: p.color,
      textTransform: "uppercase",
    }}>
      {p.label}
    </span>
  );
}
